var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticStyle:{"display":"flex","align-content":"center","align-items":"center"},attrs:{"cols":"7","lg":"10","md":"10","sm":"6"}},[_c('h3',[_vm._v("Loading...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }